/** แม่แบบในสตูดิโอ — จองห้อง+ครูตอนขายได้ (ไม่ใช่ off_site) */
export function isStudioPrivateLessonTemplate(
  template: { defaultLocationKind?: string | null } | null | undefined,
): boolean {
  return Boolean(template && template.defaultLocationKind !== "off_site");
}

export type SellPlScheduleFormSlice = {
  plScheduleWithSale: boolean;
  plSessions: unknown[];
  plInstructorIds: string[];
  plDefaultRoomId: string;
};

/** ตั้งค่า checkbox จองตอนขายตาม default location ของแม่แบบ */
export function getSellPlScheduleDefaultsForTemplate(
  template: { defaultLocationKind?: string | null } | null | undefined,
): Partial<SellPlScheduleFormSlice> {
  if (!template) {
    return {};
  }
  const isStudio = isStudioPrivateLessonTemplate(template);
  if (isStudio) {
    return { plScheduleWithSale: true };
  }
  return {
    plScheduleWithSale: false,
    plSessions: [],
    plInstructorIds: [],
    plDefaultRoomId: "",
  };
}
